import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { Apollo } from 'apollo-angular';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService {

  constructor(private apollo: Apollo) { }

  addDocumento(){
    return gql`
      mutation createDocumento($input: createDocumentoInput!) {
      createDocumento(input: $input) {
        documento {
          id
          nombre
          tipo
          idPadre
          url
          seguridadSocial
          hacienda
          contratista {
            id
            nombreComercial
            comentariosSeguridadSocial {
              comentario
              fecha
            }
          }
          gestor {
            nombre
            id
          }
          transportista {
            nombre
            id
          }
          centro {
            nombre
            id
          }
          comentariosNuevos
          comentarios {
            comentario
            fecha
            causa
          }
          createdAt
          fechaCaducidad
          noCaduca
          nombreArchivo
          
        }
      }
    }
    `;
  }

  

  

  getAllDocumentosValidados() {
    return gql`
      query getAllDocumentosValidados {
        documentos(
          where: {
            validado: true
          },
          sort: "comentariosNuevos:desc"
        )
        {
          id
          nombre
          tipo
          idPadre
          contratista {
            nombreComercial
            id
          }
          gestor {
            nombre
            id
          }
          transportista {
            nombre
            id
          }
          centro {
            nombre
            id
          }
          comentariosNuevos
          comentarios {
            comentario
            fecha
            causa
          }
          createdAt
          fechaCaducidad
          caducado
          noCaduca
          proximoCaduca
          enFecha
          solicitudReemplazo
        }
      }
    `;
  }

  getAllDocumentosValidadosDoughnut() {
    return gql`
      query getAllDocumentosValidados {
        documentos(
          where: {
            validado: true
          },
          sort: "comentariosNuevos:desc"
        )
        {
          tipo
          caducado
          proximoCaduca
          enFecha
        }
      }
    `;
  }

  getAllDocumentosValidos() {
    return gql`
      query getAllDocumentosValidos {
        documentos(
          where: {
            validado: true
          }
        )
        {
          id
          nombre
          tipo
          validado
          contratista {
            id
          }
          gestor {
            id
          }
          transportista {
            id
          }
          centro {
            id
          }
          createdAt
          fechaCaducidad
          caducado
          noCaduca
          proximoCaduca
          enFecha
        }
      }
    `;
  }

  getAllDocumentosSinValidar() {
    return gql`
      query getAllDocumentosSinValidar {
        documentos(
          where: {
            validado: false
          },
          sort: "comentariosNuevos:desc"
        )
        {
          id
          nombre
          tipo
          nombreArchivo
          idPadre
          contratista {
            nombreComercial
          }
          gestor {
            nombre
          }
          transportista {
            nombre
          }
          centro {
            nombre
          }
          comentariosNuevos
          comentarios {
            comentario
            fecha
            causa
          }
          createdAt
          fechaCaducidad
        }
      }
    `;
  }


  getDocumentoById(){
    return gql`
      query getDocumentoById($id: ID!) {
        documento(id: $id) {
          id
          nombre
          createdAt
          fechaValidez
          fechaCaducidad
          obligatorio
          validado
          caducado
          nombreArchivo
          proximoCaduca
          enFecha
          tipo
          url
          noCaduca
          subidoPor
          contratista {
            id
            nombreComercial
            comentariosSeguridadSocial {
              comentario
              causa
              fecha
            }
            comentariosHacienda {
              comentario
              causa
              fecha
            }
          }
          centro{
            nombre
            id
            comentariosResPeligrosos {
              comentario
              causa
              fecha
            }
            comentariosResNoPeligrosos {
              comentario
              causa
              fecha
            }
            comentariosContrato1{
              comentario
              causa
              fecha
            }
            comentariosContrato2{
              comentario
              causa
              fecha
            }
            comentariosContrato3{
              comentario
              causa
              fecha
            }
            comentariosJustResiduos {
              comentario
              causa
              fecha
            }
           
          }
          gestor{
            nombre
            id
            comentariosAutorizacion1 {
              comentario
              causa
              fecha
            }
            comentariosAutorizacion2 {
              comentario
              causa
              fecha
            }
            comentariosAutorizacion3 {
              comentario
              causa
              fecha
            }
            comentariosAutorizacion4 {
              comentario
              causa
              fecha
            }
            comentariosAutorizacion5 {
              comentario
              causa
              fecha
            }
          }
          transportista{
            nombre
            id
            comentariosAutorizacion1{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion2{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion3{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion4{
              causa
              fecha
              comentario
            }
            comentariosAutorizacion5{
              causa
              fecha
              comentario
            }
          }
          subidoPor
          comentariosNuevos
          seguridadSocial
          hacienda
          idPadre
          solicitudReemplazo
          comentarios {
            comentario
            fecha
            causa
          }
        }
      }
    `;
  }

  getDocumentosByContratista(){
    return gql`
      query getDocumentosByContratista($id: ID!){
        contratista(id: $id){
          centros{
            documentos{
              id
              nombre
              tipo
              caducado
              enFecha
              proximoCaduca
            }
          }
          documentos {
            id
            nombre
            fechaValidez
            fechaCaducidad
            contratista {
              nombreComercial
            }
            createdAt
            fechaCaducidad
            caducado
            hacienda
            seguridadSocial
            validado
            proximoCaduca
            enFecha
            tipo
            idPadre
          }
        }
      }
    `;
  }

  getDocumentosByContratistaBar(){
    return gql`
      query getDocumentosByContratista($id: ID!){
        contratista(id: $id){
          id
          estado
          centros{
            documentos{
              id
              tipo
              estado
            }
          }
          documentos {
            id
            tipo
            estado
            
          }
        }
      }
    `;
  }

  getDocumentosByContratistaDoughnut(){
    return gql`
      query getDocumentosByContratista($id: ID!){
        contratista(id: $id){
          documentos(
            where: {
              validado: true
            },
            
          )
          {
            estado
            tipo
          }
        }
      }
    `;
  }
  
  getDocumentosByGestor(){
    return gql`
      query getDocumentosByGestor($id: ID!){
        gestor(id: $id){
      
          documentos {
            id
            nombre
            fechaValidez
            fechaCaducidad
            createdAt
            noCaduca
            subidoPor
            gestor {
              nombre
              id
            }
            caducado
            validado
            proximoCaduca
            enFecha
            nombreArchivo
            tipo
            idPadre
          }
        }
      }
    `;
  }

  getDocumentosByGestorDoughnut(){
    return gql`
      query getDocumentosByGestor($id: ID!){
        gestor(id: $id){
          documentos(
            where: {
              validado: true
            },
            
          )
          {
            estado
            tipo
          }
        }
      }
    `;
  }

  getDocumentosByGestorBar(){
    return gql`
      query getDocumentosByGestor($id: ID!){
        gestor(id: $id){
          id
          estado
          documentos {
            id
            tipo
            estado
          }
        }
      }
    `;
  }

  getDocumentosByTransportistaDoughnut(){
    return gql`
      query getDocumentosByTransportista($id: ID!){
        transportista(id: $id){
          documentos(
            where: {
              validado: true
            },
            
          )
          {
            estado
            tipo
          }
        }
      }
    `;
  }

  getDocumentosByCentroDoughnut(){
    return gql`
      query getDocumentosByCentro($id: ID!){
        centro(id: $id){
          documentos(
            where: {
              validado: true
            },
            
          )
          {
            estado
            tipo
          }
        }
      }
    `;
  }

  getDocumentosByTransportista(){
    return gql`
      query getDocumentosByTransportista($id: ID!){
        transportista(id: $id){
          documentos {
            id
            nombre
            fechaValidez
            fechaCaducidad
            createdAt
            noCaduca
            estado
            gestor {
              nombre
              id
            }
            caducado
            validado
            proximoCaduca
            enFecha
            nombreArchivo
            tipo
            idPadre
          }
        }
      }
    `;
  }

  getDocumentosByTransportistaBar(){
    return gql`
      query getDocumentosByTransportista($id: ID!){
        transportista(id: $id){
          id
          estado
          documentos {
            id
            estado
            tipo
          }
        }
      }
    `;
  }

  getDocumentosByCentro(){
    return gql`
      query getDocumentosByCentro($id: ID!){
        centro(id: $id){
          id
          documentos {
            id
            nombre
            fechaValidez
            fechaCaducidad
            createdAt
            noCaduca
            gestor {
              nombre
              id
            }
            caducado
            validado
            proximoCaduca
            enFecha
            nombreArchivo
            tipo
            idPadre
            fechaCheck
          }
        }
      }
    `;
  }

  getDocumentosByCentroBar(){
    return gql`
      query getDocumentosByCentro($id: ID!){
        centro(id: $id){
          id
          estado
          gestors{
            documentos{
              tipo
              estado
            }
          }
          transportistas{
            documentos{
              tipo
              estado
            }
          }
          documentos {
            id
            tipo
            estado
            gestor {
              nombre
              id
            }
            
          }
        }
      }
    `;
  }


getDocumentosCentrosByCliente(){
    return gql`
      query getDocumentosCentrosByCliente($id: ID!){
        cliente(id: $id){
          id
          centros{
            documentos {
              id
              nombre
              fechaValidez
              fechaCaducidad
              createdAt
              noCaduca
              gestor {
                nombre
                id
              }
              caducado
              validado
              proximoCaduca
              enFecha
              nombreArchivo
              tipo
              idPadre
            }
          }
          }
          
      }
    `;
  }

  getDocumentosCentrosByClienteBar(){
    return gql`
      query getDocumentosCentrosByCliente($id: ID!){
        cliente(id: $id){
          id
          centros{
            contratista{
              id
            }
            documentos {
              id
              estado
              tipo
              
              
            }
          }
          }
          
      }
    `;
  }

  getDocumentosCentroByInstalacion(){
    return gql`
      query getDocumentosCentroByInstalacion($id: ID!){
        instalacion(id: $id){
          id
          centro{
            documentos {
              id
              nombre
              fechaValidez
              fechaCaducidad
              createdAt
              noCaduca
              gestor {
                nombre
                id
              }
              caducado
              validado
              proximoCaduca
              enFecha
              nombreArchivo
              tipo
              idPadre
            }
          }
          }
          
      }
    `;
  }

  getDocumentosCentroByInstalacionBar(){
    return gql`
      query getDocumentosCentroByInstalacion($id: ID!){
        instalacion(id: $id){
          id
          centro{
            documentos {
              id
              tipo
              estado
              gestor {
                nombre
                id
              }
              
            }
          }
          }
          
      }
    `;
  }
  updateDocumentoById(){
    return gql`
      mutation updateDocumento($input: updateDocumentoInput!) {
        updateDocumento(input: $input) {
          documento {
            id
            tipo
            idPadre
            url
            validado
            estado
            comentariosNuevos
          }
        }
      }
    `;
  }

  deleteDocumentoById(){
    return gql`
      mutation deleteDocumento($input: deleteDocumentoInput!) {
        deleteDocumento(input: $input) {
          documento {
            id
          }
        }
      }
    `;
  }


  getAllDocumentos() {
    return gql`
      query getAllDocumentos{
        documentos {
          id
          tipo
          caducado
          proximoCaduca
          enFecha
          noCaduca
          fechaCaducidad
          fechaCheck
        }
      }
    `;
  }

  getDocumentosTransportistas(){
    return gql`
      query getDocumentosTransportistas {
          documentos(
            where: 
             { 
              gestor_null: false} 
            )
            {
              id
              enFecha
              caducado
              proximoCaduca
              tipo
              validado
              transportista{
                id
              }
              gestor{
                id
              }
            }
        }
    `;
  }
  
  setComentariosLeidos(id: string){
    return this.apollo.mutate({
      mutation: this.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "comentariosNuevos": false
          }
        }   
      }
    })
  }

  getCentros() {
    return gql`
      query getCentros {
        centros {
          id
          documentos {
            centro{
              id
            }
            id
            tipo
            validado
            noCaduca
            enFecha
            caducado
            proximoCaduca
            nombreArchivo
          }
          gestors {
            id
            documentos {
            id
            tipo
            validado
            noCaduca
            enFecha
            caducado
            proximoCaduca
            nombreArchivo
          }
          }
        }
      }
    `;
  }

  getGestorByCentro(){
    return gql`
      query getGestorByCentro($id: ID!){
        centro(id: $id){
          gestors {
            id
            documentos {
            id
            tipo
            validado
            noCaduca
            enFecha
            caducado
            proximoCaduca
            nombreArchivo
            }
          }
        }
      }
    `;
  }

  getActualDate(){
    return moment(new Date(), 'day').format('YYYY-MM-DD')
  }

  getNextMonth(){
    return moment(new Date(), 'day').add(30, 'days').format('YYYY-MM-DD')
  }
}
